import { useEffect } from 'react';

import { Button } from '@mui/material';
import Container from '@mui/material/Container';

import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';

import { getBarItemById } from 'src/redux/slices/bar';

import ErrorContent from 'src/components/error-content';
import { useSettingsContext } from 'src/components/settings';
import { LeftIcon } from 'src/components/carousel/arrow-icons';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';

import BarItemDetails from '../bar-details';
import { LoadingScreen } from '../../../components/loading-screen';
import { useAppDispatcher, useAppSelector } from '../../../redux/store';

type Props = {
  id: string;
};

export default function BarDetailView({ id }: Props) {
  const { item, status, error } = useAppSelector((state) => state.bar);

  const settings = useSettingsContext();
  const dispatch = useAppDispatcher();

  useEffect(() => {
    dispatch(getBarItemById({ itemID: id }));
  }, [dispatch, id]);

  if (status === 'loading' || status === 'idle') {
    return <LoadingScreen />;
  }

  if (status === 'failure') {
    return (
      <ErrorContent
        filled
        title="Failed to load bar item details"
        description={error}
        action={
          <Button
            component={RouterLink}
            href={paths.dashboard.bar.root()}
            variant="contained"
            startIcon={<LeftIcon />}
          >
            Back to Bar Items
          </Button>
        }
        sx={{
          py: 10,
        }}
      />
    );
  }

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <CustomBreadcrumbs
        heading="Bar Item Details"
        links={[
          {
            name: 'Bar Items',
            href: paths.dashboard.bar.root(),
          },
          { name: 'Bar Item Details' },
        ]}
        sx={{
          mb: { xs: 3, md: 5 },
        }}
      />

      <BarItemDetails currentBarItem={item} />
    </Container>
  );
}
